<template>
  <div class="modal fade" :id="id" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog">
      <form @submit.prevent="submitForm" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{!edit ? $t('reminder.create') : $t('reminder.update')}}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" 
                            fill="currentColor" />
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor" />
                    </svg>
                  </span>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-3 d-flex align-items-center">
                <label :for="`input-${id}-task-alert-delay-value`">
                  {{ $t('reminder.advertisement') }}
                </label>
              </div>
              <Input
                  :name="`${id}-task-alert-delay-value`"
                  container-class="col-9 mb-5"
                  type="number"
                  :isRequired="false"
                  size="lg"
                  v-model="formData.delay_value_alert"
                  :IsInputGroup="true"
                  placeholder-text="Ex: 5"
              >
                <span class="input-group-text w-50 border-0 py-0">
                  <Select2
                      container-class="w-100 p-0"
                      select-class="form-select form-select-transparent w-100 fs-7 lh-1 fw-bold py-0 select2-hidden-accessible"
                      :isRequired="false"
                      :multiple="false"
                      :show-search="true"
                      :name="`${id}-task-alert-delay-unit`"
                      v-model="formData.delay_unit_alert"
                      label-class="form-label"
                      :parent-id="'#'+id"
                      :placeholder-text="$t('reminder.frequency')"
                  >
                        <option v-for="delay in delayFrequencyEnum" :key="delay.value" :value="delay.value"> {{ delay[locale] }} </option>
                    </Select2>
                </span>
              </Input>
            </div>
            <div class="row">
              <div class="col-3 d-flex align-items-center">
                <label :for="`input-${id}-task-critical-delay-value`">
                  {{ $t('reminder.inLate') }}
                </label>
              </div>
              <Input
                  :name="`${id}-task-alert-delay-value`"
                  container-class="col-9 mb-5"
                  type="number"
                  :isRequired="false"
                  size="lg"
                  v-model="formData.delay_value_critical"
                  :IsInputGroup="true"
                  placeholder-text="Ex: 5"
              >
                <span class="input-group-text w-50 border-0 py-0">
                  <Select2
                      container-class="w-100 p-0"
                      select-class="form-select form-select-transparent w-100 fs-7 lh-1 fw-bold py-0 select2-hidden-accessible"
                      :isRequired="false"
                      :multiple="false"
                      :show-search="true"
                      :name="`${id}-task-critical-delay-unit`"
                      v-model="formData.delay_unit_critical"
                      :placeholder-text="$t('reminder.frequency')"
                      label-class="form-label"
                      :parent-id="'#'+id"
                  >
                        <option v-for="delay in delayFrequencyEnum" :key="delay.value" :value="delay.value"> {{ delay[locale] }} </option>
                    </Select2>
                </span>
              </Input>
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import {ref, defineEmits, defineProps, watch} from "vue";
import Input from "@/components/Input.vue";
import Button from "@/components/Button.vue";
import { useStore } from "vuex";
import { computed } from "vue";
import Select2 from "@/components/Select2.vue";
import {useLocales} from "@/composables/locales";

const store = useStore();
const { locale } = useLocales()
const emits = defineEmits(["addConfig"]);

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  form: {
    type: Object,
    default: () => ({
      delay_value_alert: "",
      delay_unit_alert: "",
      delay_value_critical: "",
      delay_unit_critical: ""
    }),
  },
  edit: {
    type: Boolean,
    default: false,
  },
  parent: {
    type: String,
    required: false
  },
});


const isLoading = ref(false);
const formData = ref(props.form);

const delayFrequencyEnum = computed(() => store.getters["configs/getFrequencyEnum"])

watch(
    () => props.form,
    (newForm) => {
      formData.value = { ...newForm };
    },
    { deep: true }
);

function closeModal() {
  if(props.parent){
      $('#'+props.parent).modal('toggle')
  }
  $("#" + props.id).modal("toggle");
}

function submitForm() {
  emits('addConfig', formData.value)
  closeModal()
}
</script>

<style scoped>

</style>
